<template>
  <div class="con">
    <div class="flexbox">
      <div class="vbox">
        <img :src="intro.image&&intro.image[0]" alt="">
      </div>
      <div class="despbox">
        <div class="title">企业介绍</div>
        <div class="text" v-html="intro.description"></div>
      </div>
    </div>
    <div class="imglist">
      <div class="img-box" @click="zoom" :data-idx="index" v-for="(item,index) in intro.image" v:key="id" v-if="index!==0">
        <img :src="item" alt="">
        <div class="mask"><i class="el-icon-view"></i></div>
      </div>
    </div>

    <div class="big-title">本届展位</div>

    <div class="box1">
      <div class="title">{{intro.business_type}}</div>
      <p>位置：{{intro.booth}}</p>
      <p>联营企业：{{intro.name}}</p>
    </div>

    <div class="big-title">基本信息</div>
    <ul class="box2">
      <li>
        <span>企业名称：</span>
        <span>{{intro.name}}</span>
      </li>
      <li>
        <span>企业类型：</span>
        <span>{{intro.enterprise_type}}</span>
      </li>
      <li>
        <span>成立年份：</span>
        <span>{{intro.year}}</span>
      </li>
      <li>
        <span>注册资本：</span>
        <span>￥{{intro.capital}}</span>
      </li>
      <li>
        <span>企业规模：</span>
        <span>{{intro.scale}}</span>
      </li>
      <li>
        <span>主要目标客户：</span>
        <span>{{intro.customer}}</span>
      </li>
      <li>
        <span>主营产品：</span>
        <span>{{intro.exhibit}}</span>
      </li>
      <li>
        <span>地址：</span>
        <span>{{intro.address}}</span>
      </li>
      <li>
        <span>所在地区：</span>
        <span>{{intro.region}}</span>
      </li>
      <li>
        <span>网址：</span>
        <span>{{intro.website}}</span>
      </li>
    </ul>

    <div class="flexbox btnbox">
      <Btn @click.native="openCommitBox" title="预约洽谈" icon="el-icon-time" color="red"></Btn>
    </div>

   <Commit :show="dialogFormVisible" v-on:close="dialogFormVisible=false"></Commit>

  </div>
</template>

<script>
import Btn from '@/components/Button/Btn.vue';
import Commit from '../components/Commit.vue';


export default {
  name: '',
  components:{Btn,Commit},
  props:{
    intro:{type:Object,default:{}}
  },
  data(){
    return {
      dialogFormVisible:false
    }
  },
  mounted(){
    console.log(this.intro);
  },
  methods:{
    zoom(e){
      const index = e.currentTarget.dataset.idx;
      let zooms = this.intro.image.map(res=>{
        return {picture:res};
      })
      this.$store.commit("zoom/setIdx",index);
      this.$store.commit("zoom/setList",zooms);
      this.$store.commit("zoom/setVisible",true);
    },
    openCommitBox(){
      this.dialogFormVisible=true;
    },
  }
}
</script>

<style scoped>
.img-box .mask{position:absolute; top:0;bottom:0;left:0;right:0; background:rgba(0,0,0,.5); display:flex; transition-duration:300ms; opacity:0;}
.img-box .mask>i{font-size:2vw; color:#fff; display:block; margin:auto; transition-duration:300ms; transform:scale(.5);}
.img-box:hover .mask{opacity:1;}
.img-box:hover .mask>i{transform:scale(1);}

.con{padding:2vw 1.5vw;}
.con .flexbox{display:flex; font-size:0;}
.con .flexbox .vbox{flex:0 0 49.5vw; width:49.5vw; height:25.8vw; border:1px solid #eee; box-sizing:border-box;}
.con .flexbox .vbox>img{width:49.5vw; height:25.8vw; object-fit:cover;}
.con .flexbox .despbox{flex:1 1 auto; height:24.8vw; padding:0.5vw 1vw; background:#f7f7f7;}
.con .flexbox .despbox .title{font-size:1.2vw; color:#111; height:3vw; line-height:3vw; font-weight:bold;}
.con .flexbox .despbox .text{font-size:1vw; color:#666; height:21vw; overflow:auto;}

.imglist{margin-top:1.5vw; display:flex;}
.imglist .img-box{margin-right:1.5vw; position: relative; cursor:pointer; font-size:0;}
.imglist .img-box img{height:10vw;}

.big-title{font-size:2vw; font-weight:bold; padding:2vw 0;}

.box1{background:#f7f7f7; padding:1vw 1vw;}
.box1 .title{font-size:1.4vw; font-weight:bold; margin-bottom:0.6vw;}
.box1 p{font-size:1.2vw; color:#999; margin-bottom:0.2vw;}

.box2{display:flex; flex-wrap: wrap; font-size:0;}
.box2 li{flex:0 0 41.5vw; width:41.5vw; height:2.8vw; line-height:2.8vw; font-size:0.9vw; border-bottom:1px solid #eee;}
.box2 li>span:nth-of-type(1){color:#999; display:inline-block; width: 8vw;}
.box2 li>span:nth-of-type(2){color:#222;}

.btnbox{display:flex; justify-content: center;}
.btnbox{margin-top:3vw;}
.btnbox .main-button{width:15vw; height:3.28vw; margin:1vw auto 0 auto; font-size:1.1vw; }

@media (max-width:991px){
.con{padding:4vw 3vw;}
.con .flexbox{flex-wrap: wrap; justify-content: center;}
.con .flexbox .vbox{flex:0 0 94vw; width:94vw; height:48vw;}
.con .flexbox .vbox>img{width:94vw; height:48vw; object-fit:cover;}
.con .flexbox .despbox{flex:0 0 90vw; width:90vw; height:auto; padding:1.5vw 2vw; margin-top:2vw;}
.con .flexbox .despbox .title{font-size:4vw; line-height:6vw; }
.con .flexbox .despbox .text{margin-top:4vw;font-size:3vw; line-height:4vw; color:#666; height:auto; overflow:auto;}

.imglist{margin-top:3vw; width:94vw; overflow-x: auto; display:flex; justify-content:center;}
.imglist .img-box{width:29vw; height:29vw; margin-right:3vw; display:flex; border:1px solid #eee;}
.imglist .img-box:nth-last-of-type(1){margin-right:0;}
.imglist .img-box img{height:auto; max-width:29vw; max-height:29vw; margin:auto;}

.big-title{font-size:5vw; font-weight:bold; padding:4vw 0;}

.box2 li{flex:0 0 94vw; width:94vw; height:9vw; line-height:9vw; font-size:3.6vw;}
.box2 li>span:nth-of-type(1){color:#999; display:inline-block; width:35vw;}
.btnbox .main-button{width:55vw; height:10vw; margin:1vw auto 0 auto; font-size:3.4vw; }
}
</style>